import moment from 'moment';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const checkActiveSubscription = (currentUser, keyName) => {
  const subscriptionPlan = currentUser?.attributes?.profile?.publicData?.[keyName]?.currentPlanName;
  if (!subscriptionPlan) {
    return false;
  }
  // Check if use has not subscribed to a free plan.
  if (subscriptionPlan != 'free') {
    const expiryDate =
      currentUser?.attributes?.profile?.publicData?.[keyName]?.currentPlanDetails?.expiry;
    if (moment().unix() > +expiryDate) {
      return false;
    }
  }
  return true;
};

const checkBuyerSubscription = currentUser => {
  return (
    checkActiveSubscription(currentUser, 'buyerPlan') ||
    checkActiveSubscription(currentUser, 'sellerPlan')
  );
};

const getCurrentLanguage = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get('local') || 'en';
};

const urlWithLang = url => {
  const local = getCurrentLanguage();
  return local === 'de' ? `${url}?local=${local || "en"}` : url;
};

const getcurrencySymbol = () => {
  const local = getCurrentLanguage();
  return local === 'de' ? '€' : '£';
};

const formatCurrency = (amount, symbolAfter = false) => {
    return (
      <>
        {symbolAfter ? '' : getcurrencySymbol()}{+amount ? new Intl.NumberFormat('en-US').format(amount / 100) : 0}
      </>
    );
};

export {
  checkActiveSubscription,
  getcurrencySymbol,
  checkBuyerSubscription,
  formatCurrency,
  getCurrentLanguage,
  urlWithLang,
};
